import { inject, Injectable } from '@angular/core';
import { AnimationController } from '@ionic/angular';
import { ModalPosition } from '../models';

const TRANSFORM_BY_POSITION: Record<ModalPosition, string> = {
  right: 'translateX(100%)',
  left: 'translateX(-100%)',
  bottom: 'translateY(100%)',
  top: 'translateY(-100%)',
};

@Injectable({
  providedIn: 'root',
})
export class AnimationsService {
  #animationCtrl = inject(AnimationController);

  /** Builds an enter animation that slides in from the given edge. */
  createSideEnterAnimation = (position: ModalPosition = 'right') => {
    const offscreenTransform = TRANSFORM_BY_POSITION[position];

    return (baseEl: HTMLElement) => {
      const root = baseEl.shadowRoot;

      const backdropAnimation = this.#animationCtrl
        .create()
        .addElement(root?.querySelector('ion-backdrop')!)
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

      const wrapperAnimation = this.#animationCtrl
        .create()
        .addElement(root?.querySelector('.modal-wrapper')!)
        .keyframes([
          { offset: 0, opacity: '1', transform: offscreenTransform },
          { offset: 1, opacity: '1', transform: 'translate(0, 0)' },
        ]);

      return this.#animationCtrl
        .create()
        .addElement(baseEl)
        .easing('cubic-bezier(0.5, 0, 0, 1)')
        .duration(300)
        .addAnimation([backdropAnimation, wrapperAnimation]);
    };
  };

  /** Builds a leave animation that reverses the corresponding enter animation. */
  createSideLeaveAnimation = (position: ModalPosition = 'right') => {
    return (baseEl: HTMLElement) => {
      return this.createSideEnterAnimation(position)(baseEl).direction('reverse');
    };
  };
}